<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="showUploadConfirm=true">
            <i class="fa fa-file"></i> Upload
          </button>
           <button class="btn btn-primary mr-1" @click="ekstrakData">
            <i class="fa fa-rss"></i> Extract Data
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
     <!--  <b-row v-if="showFilter">
        <b-col lg="5">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.no_agreement" placeholder="No Agreement"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.no_kontrak" placeholder="No Kontrak"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Debitur</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.CustName" placeholder="Debitur Name"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">CIF</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.CustCode" placeholder="Debitur No. (CIF)"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.branch" placeholder="Branch"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.LDSK" placeholder="LDSK"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Tgl. Surat</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label class="label-eko">Status Surat</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.statussp" :plain="true" :options="optStatusSurat" style="min-width:70px !important;"></b-form-select>
            <b-input-group-prepend>
              <label class="label-eko pt-2">Expired in (<=)</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.expired_in_days" type="number" min="0"></b-form-input>
            <b-input-group-append>
              <b-input-group-text style="    height: 35px;">
                Days
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
                  <label class="label-eko">NO SP</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.nosurat" placeholder="No. SP"></b-form-input>
            <b-input-group-prepend>
              <label class="label-eko">Jenis Surat</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.jenissuratkey" :plain="true" :options="optJenisSurat"></b-form-select>
          </b-input-group>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Issued by</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.createby" placeholder="Issued by"></b-form-input>
                <b-input-group-prepend>
                  <label class="label-eko">Collector</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors"></b-form-select> 
              </b-input-group>
            </b-col>
            <b-col lg="12">
              <b-input-group>
                
                <b-input-group-prepend>
                  <label class="label-eko">Delivery Status</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.delivery_status" :plain="true" :options="optDeliveryStatus" style="min-width:70px !important;"></b-form-select>

                <b-input-group-prepend>
                  <label>Last Payment Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgllast1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgllast2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div class="text-right mb-2 mt-1">
            <b-button variant="success" size="sm" @click="refresh()" class="ml-3">
              <i class="fa fa-refresh"></i> Apply Filter
            </b-button>
            <b-button
              variant="secondary"
              size="sm"
              class="ml-2"
              @click="clearFilter()"
            >Clear Filter</b-button>
          </div>
        </b-col>
      </b-row> -->
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        :busy="isBusy"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{ data.index+1 }}</template>
        <template v-slot:cell(debitur_name)="data">{{ data.item.CustCode}} | {{data.item.CustName}}</template>
        <template
          v-slot:cell(created_at)="data"
        >{{ data.item.created_at | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(dokumen_dasar_tanggal)="data"
        >{{ data.item.dokumen_dasar_tanggal | moment("DD MMM YYYY") }}</template>
        
        <template v-slot:cell(jumlah_dpp)="data">{{ data.item.jumlah_dpp | numFormat('0,0.00') }}</template>
        <template v-slot:cell(jumlah_pph)="data">{{ data.item.jumlah_pph | numFormat('0,0.00') }}</template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

    <b-modal v-model="showUploadConfirm" header-bg-variant="primary"  title="Upload" size="lg" :centered="true" hide-footer>
          <b-form-file
            v-model="file"
            :multiple="true"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            ></b-form-file>
          <hr />
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="submitBupot"><i class="fa fa-paper-plane"></i> Submit</b-button>
              <b-button variant="secondary" class="ml-1" @click="showUploadConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>


      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>

  </div>
</template>
<style scoped>
  .label-eko{
    max-width: 100px;
  }
</style>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
import documents from "../../apis/documents";
import crud from "../../apis/crud";
// import Terbilang from 'terbilang-ts';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();
export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      tipepengiriman: { required },
      tglkirim: { required },
      tglretur: { required },
      alasanretur: { required },
    },
    sendspdt:{
      tipepengiriman: { required },
      tglkirim: { required },
    },
    returspdt:{
        tglretur: { required },
        alasanretur: { required },
        description: { required }
      },
    followupspdt:{
        post_date: { required },
        activity_update: { required }
      },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      // start print
      isLoading: false,
      showReport: false,
      reportUrl: "",
      // end print
      showSendConfirm: false,
      showUploadConfirm: false,
      showFollowUpConfirm:false,
      showDelConfirm: false,
      file:null,
      model: {
        tipepengiriman: "",delivery_status:''
      },
      sendspdt:{
        tglkirim:'',tipepengiriman:'',namapengirim:'',noresi:''
      },
      returspdt:{
        tglretur:'',alasanretur:'',description:'',isupdateaddress:'0',nasabahkey:'',
        alamat:'',
        rt:'',
        rw:'',
        kelurahan:'',
        kecamatan:'',
        kota:'',provinsi:'',
        kodepos:'',
      },
      followupspdt:{
        post_date: '',
        activity_update: ''
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:moment().startOf('month').format('YYYY-MM-DD'),
        tgl2:moment().endOf('month').format('YYYY-MM-DD'),
        sortBy: "created_at",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        kolektibiltas: "",
        jenissuratkey: null,
        status:'',CustCode:'',CustName:'',createby:'',nosurat:'',
        no_kontrak:'',no_agreement:'',expired_in_days:'',
        branch:'', LDSK:'',statussp:'',delivery_status:''
      },
      collectors: [{ value: "", text: "-- ALL --" }],
      modelkredit: [
        { value: "", text: "-- ALL --" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "-- ALL --" },
        { value: "KOL1", text: "KOL-1" },
        { value: "KOL2", text: "KOL-2" },
        { value: "KOL3", text: "KOL-3" },
        { value: "KOL4", text: "KOL-4" },
        { value: "KOL5", text: "KOL-5" },
      ],
      statuses: [
        { value: "", text: "-- ALL --" },
        { value: "secure", text: "Perform(Secure)" },
        { value: "unsecure", text: "Non Perform" },
      ],
      optStatusSurat:[
        { value: "", text: "-- ALL --" },
        { value: "gugur", text: "Gugur" },
        { value: "lancar", text: "Lancar" },
        { value: "expired", text: "Expired" },
      ],
      optDeliveryStatus:[
        { value: "", text: "-- ALL --" },
        { value: "send", text: "Send" },
        { value: "return", text: "Return" },
      ],
      optJenisSurat: [
        {
          value: null,
          text: "-- Please select an option --",
          disabled: true,
        },
      ],
      optTipePengiriman: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "internal", text: "Internal" },
        // { value: "jasakirim", text: "Jasa Pengiriman" },
        { value: "jne", text: "JNE" },
        { value: "tiki", text: "TIKI" },
        { value: "pos", text: "POS Indonesia" },
        { value: "wahana", text: "Wahana" },
        { value: "jnt", text: "J & T Express" },
        { value: "sicepat", text: "Sicepat Express" },
        { value: "rpx", text: "RPX Express" },
      ],
      optAlasanRetur: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "addressnotcomplete", text: "Alamat Tidak Lengkap" },
        { value: "nomatch", text: "Tidak Sesuai" },
        { value: "notfound", text: "Tidak Ketemu" },
        { value: "changeaddress", text: "Pindah Alamat" },
        { value: "broken", text: "Rusak" },
      ],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidSendSP() {
      this.$v.sendspdt.$touch();
      return this.$v.sendspdt.$invalid;
    },
    invalidReturSP() {
      this.$v.returspdt.$touch();
      return this.$v.returspdt.$invalid;
    },
    invalidFollowupsp() {
      this.$v.followupspdt.$touch();
      return this.$v.followupspdt.$invalid;
    },
    ifInternal() {
      return this.sendspdt.tipepengiriman == "internal" ? true : false;
    },
    tblFields() {
      const fields = [
        {
          key: "filename",
          label: "Filename",
          thStyle: "width:90px",
          thClass: "text-center",
          sortable: true,
        },
                {
          key:"nomor_bukti_potong", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        // {
        //   key:"masa_pajak_bulan", 
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true 
        // },
        {
          key:"masa_pajak_tahun", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        /* {
          key:"status_bukti_potong", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"sifat_pemotongan", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        }, */
        {
          key:"wp_dipotong_npwp", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        /* {
          key:"wp_dipotong_nitku", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        }, */
        {
          key:"wp_dipotong_nama", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"kode_objek_pajak", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        // {
        //   key:"uraian_objek_pajak", 
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true 
        // },
        // {
        //   key:"jenis_fasilitas", 
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true 
        // },
        {
          key:"jumlah_dpp", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"tarif_persen", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"jumlah_pph", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"dokumen_dasar_jenis", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"dokumen_dasar_nomor", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"dokumen_dasar_tanggal", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        {
          key:"pemotong_npwp", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        /* {
          key:"pemotong_nitku", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        }, */
        {
          key:"pemotong_nama", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        },
        /* {
          key:"pemotong_penandatangan", 
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true 
        }, */
        // {
        //   key:"tanggal_bukti_potong", 
        //   thClass: "text-center",
        //   tdClass: "text-center",
        //   sortable: true 
        // },
        {
          key: "upload_by",
          label: "Upload Oleh",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Upload At",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    
 
  },
  methods: {
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        
        const list = await documents.listBuktiPotong(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async submitBupot(){
        try {
            const formData = new FormData();
            for (let i = 0; i < this.file.length; i++) {
                formData.append('file', this.file[i]);
                formData.append('filename', this.file[i].name);
            }

            console.log('formData',formData)

            const resp = await documents.uploadBuktiPotong(formData);
            this.refresh();
            this.showUploadConfirm=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }

        } catch (error) {
            console.log('error',error)
        }
    },
    async ekstrakData() {
      if (this.model.key_file) {
        await documents.ekstrakBuktiPotong(this.model)
        this.refresh();
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async refresh() {
      try {
        console.log(this.tblData);
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.CustCode = "";
      this.tblData.CustName = "";
      this.tblData.collectability = "";
      this.tblData.kolektibiltas = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.tgllast1 = "";
      this.tblData.tgllast2 = "";
      this.tblData.no_kontrak = "";
      this.tblData.no_agreement = "";
      this.tblData.jenissuratkey=null;
      this.tblData.nosurat = "";
      this.tblData.status = "";
      this.tblData.statussp = "";
      this.tblData.delivery_status = "";
      this.tblData.expired_in_days = "";
      this.tblData.createby = null;
      this.tblData.collector_id = '';
      this.tblData.branch = '';
      this.tblData.LDSK = '';
      this.refresh();
    },
    async exportxls() {
      try {
        await suratperingatan.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },    
    deleteConfirm() {
        if (this.model.suratkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },

    deleteData: async function() {
      try {
        this.isLoading=true;
        const spdt = await suratperingatan.remove(this.model);
        toastr.success(`SP no. : ${spdt.nosurat} has been Deleted!`);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
            this.refresh();
            this.isLoading=false;       
      }
    },
    close() {
      router.push("home");
    },
    
    
  },
};
</script>